<template>
    <div class="mt-5">
        <DialogoCredencial ref="dialCred" :titulo="titulo"></DialogoCredencial>
        <v-btn @click="lanzarDialogo" color="primary lighten-1" class="pa-5"><v-icon
                class="mr-2">mdi-card-account-details-outline</v-icon>mi
            credencial</v-btn>
    </div>
</template>
<script>

import { mapGetters, mapActions } from 'vuex'
import DialogoCredencial from '@/components/dialogos/DialogoCredencial.vue';

export default {
    name: "CredencialCard",
    components: {
        DialogoCredencial
    },
    data() {
        return {
            titulo: '',
            ancho: '',
            tipo: '',
            url: ''
        }
    },
    methods: {
        ...mapActions('auth', ['generarCredencial']),
        lanzarDialogo() {
            this.titulo = 'Credencial virtual'
            this.$refs.dialCred.abrirDialogo()
        },

        descargarPdf() {
            this.url = process.env.VUE_APP_API
            this.url = (this.user.esjubilado) ? this.url + 'portal/credencial/imprimirPDFCredencialJubilado' : this.url + 'portal/credencial/imprimirPDFCredencialActivo'
            this.generarCredencial(this.url)
        }
    },
    computed: {
        //...mapGetters('auth', ['user', 'credencialHtml'])
        ...mapGetters('auth', ['user'])

    },
    props: ['title']
}
</script>

